export const getArtistAdminsList = (admins) => {
  if (admins.length === 1) return admins[0];
  else if (admins.length > 1) {
    let res = admins.slice(0, admins.length - 1).join(", ");
    res += ` or ${admins[admins.length - 1]}`;
    return res;
  } else return "your administrator";
};
